import { Expression } from "./abstract.expression";
import { UnaryExpression } from "./abstract.unary.expression";

export type FunctionType =
    | "contains"
    | "not contains"
    | "startswith"
    | "endswith"
    | "tolower"
    | "orderBy" /* | "toupper" */;

export abstract class FunctionExpression extends Expression
{
    constructor(
        private readonly _functionName: FunctionType,
        protected readonly field: string | UnaryExpression,
        protected readonly parameters?: string[]
    )
    {
        super();
    }

    toQuery(): string
    {
        const params = this.parameters ? "," + this.parameters.map(escapeValue).join(",") : "";
        const field = typeof this.field === "string" ? this.field : this.field.toQuery();
        return `${this._functionName}(${field}${params})`;

        function escapeValue(value: string): string
        {
            if (typeof value === "string")
            {
                return `'${encodeURIComponent(value
                    .replace(/'/g, "''")
                    .replace(/#/g, "%23")
                    .replace(/\+/g,"%2B"))}'`;
            }
            return value;
        }
    }
}
